import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@xingternal/button';
import { getTrackingUrlHOF } from '@xingternal/xing-tracking';
import { trackings } from '@xingternal/platform-layout-trackings';
import styles from './UpsellButton.css';
const getTrackingURL = getTrackingUrlHOF(trackings);
const UpsellButton = ({ showUpsellHint, showJobSeekerBoneyardUpsellHint, link, intl, }) => {
    if (!showUpsellHint)
        return null;
    const { title, href, key: trackingKey } = link;
    return (React.createElement("div", { className: styles.container },
        React.createElement(Button, { href: getTrackingURL({ to: href, trackingKey }), variant: showJobSeekerBoneyardUpsellHint ? 'proJobs' : 'premium', size: "small", "data-qa": "upsell-button" }, intl.formatMessage({ id: title }))));
};
UpsellButton.propTypes = {
    link: PropTypes.shape({
        key: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
    showUpsellHint: PropTypes.bool.isRequired,
    showJobSeekerBoneyardUpsellHint: PropTypes.bool.isRequired,
    intl: PropTypes.object.isRequired,
};
UpsellButton.defaultProps = {
    isBasic: false,
    isPremium: false,
};
export { UpsellButton };
//# sourceMappingURL=UpsellButton.js.map